import { StringFormat } from "@packages/common";
import type { FilterDTO, FilterItemDTO } from "../../search";
import { OpportunitiesTransformer } from "./opportunities-filter.transformer";

const NAME_PRODUCTS = "Products";

/**
 * Transforms `FiltersGrouped[MostUsed]`: the child node **`Products`** holds the same
 * opportunity items as the legacy {@link OpportunitiesTransformer} filter.
 *
 * A lógica de ordenação e labels replica a de `OpportunitiesTransformer.transform`,
 * usando {@link OpportunitiesTransformer.opportunitiesOrder} (somente leitura).
 */
export abstract class MostUsedTransformer {
  /**
   * Mesma regra que em `OpportunitiesTransformer.transform` para a lista plana de itens.
   */
  private static applyOpportunitiesOrderToItems(
    items: FilterItemDTO[]
  ): FilterItemDTO[] {
    if (!items?.length) {
      return [];
    }

    const { formatSlug } = StringFormat;

    return Object.entries(OpportunitiesTransformer.opportunitiesOrder)
      .map(([key, orderedLabel]) => {
        const slug = formatSlug(key);
        const matchedItem = items.find(
          (item) => formatSlug(item.name) === slug
        );
        return matchedItem
          ? {
              label: orderedLabel,
              name: matchedItem.name,
              count: matchedItem.count,
              description: matchedItem?.description ?? "",
            }
          : null;
      })
      .filter((item) => item !== null) as FilterItemDTO[];
  }

  static transform(filter: FilterDTO): FilterDTO {
    if (!filter || filter.name !== "MostUsed") {
      return filter;
    }

    const products = filter.items.find((item) => item.name === NAME_PRODUCTS);
    if (!products?.items?.length) {
      return filter;
    }

    const orderedLeaves = MostUsedTransformer.applyOpportunitiesOrderToItems(
      products.items
    );

    return {
      ...filter,
      items: filter.items.map((item) =>
        item.name === NAME_PRODUCTS ? { ...item, items: orderedLeaves } : item
      ),
    };
  }
}
